import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { ProductTypeActions, ProductTypeStore, STATUS } from 'Stores/productTypeStore'
import ProductTypeForm from 'Modules/productType/productTypeForm'

export default class ProductTypeCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [ProductTypeStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    ProductTypeActions.createEmptyProductType()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('ProductType Created', {
        autoClose: 3000,
        onClose: () => {
          ProductTypeActions.clearFormToast()
        }
      })
      ProductTypeActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('ProductType Create Failed', {
        autoClose: 3000,
        onClose: () => {
          ProductTypeActions.clearFormToast()
        }
      })
      ProductTypeActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <ProductTypeForm />
      </React.Fragment>
    )
  }
}
